import { Row, Image, Col } from "react-bootstrap"
import { ImageIndex } from "../../utils/ImageIndex";
import { FC, useEffect, useState } from "react";

interface ImageGalleryProps {
    style?: object;
}

export const ImageGallery: FC<ImageGalleryProps> = ({style}) => {
    const [imagesToUse, setImagesToUse] = useState<{ url: string; alt: string; }[]>([]);

    useEffect(() => {
        const keys = Object.keys(ImageIndex);
        const randomThree = keys.sort(() => 0.5 - Math.random()).slice(0, 3).map(url => ({url, alt: ImageIndex[url]}));
        setImagesToUse(randomThree);
    }, []);

    return(
        <div style={style}>
            {imagesToUse.length > 0 &&
            <>
                <Row className="align-items-end" style={{height:'30%', marginBottom:'3vh', transform:'translate(0px, 50px)'}}>
                    <Col xs={7}><Image src={imagesToUse[0].url} alt={imagesToUse[0].alt} fluid style={{transform: 'translate(60px, 0px)', zIndex:"10", position: 'relative', border:"3px solid white"}}/></Col>
                    <Col ></Col>
                </Row>
                <Row className="align-items-center" style={{height:'30%', marginBottom:'3vh', zIndex:"5", position: 'relative'}}>
                    <Col></Col>
                    <Col xs={9}><Image src={imagesToUse[1].url} alt={imagesToUse[1].alt} fluid style={{border:'3px solid white'}}/></Col>
                </Row>
                <Row style={{height:'20%', marginBottom:'3vh', transform:"translate(0px, -50px)"}}>
                    <Col xs={6}><Image src={imagesToUse[2].url} alt={imagesToUse[2].alt} fluid style={{transform: 'translate(20px, 0px)', border:"3px solid white"}}/></Col>
                    <Col></Col>
                </Row>
            </>
            }
        </div>
    );
}